import Bus from '@/utils/bus.js';
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};


const router =  new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: [{
            path: '/',
            name: 'login',
            meta: {
                title: '登陆',
                icon: ''
            },
            component: () =>
                import ('@/views/login/index.vue')
        },
        {
            path: '/index',
            name: 'index',
            meta: {
                title: '首页',
                icon: ''
            },
            component: () =>
                import ('@/views/index.vue'),
            redirect: '/assets',
            children: [{
                    path: '/assets',
                    name: 'assets',
                    meta: {
                        title: '持有资产信息',
                        icon: 'el-icon-pie-chart'
                    },
                    component: () =>
                        import ('@/views/assets/holding.vue')
                },
                {
                    path: '/query',
                    name: 'query',
                    redirect: '/collection',
                    meta: {
                        title: '查询业务',
                        icon: 'el-icon-office-building'
                    },
                    component: () =>
                        import ('@/views/query/index.vue'),
                    children: [{
                            path: '/collection',
                            name: 'collection',
                            meta: {
                                title: '收款账户查询',
                                icon: ''
                            },
                            component: () =>
                                import ('@/views/query/collection.vue')
                        },
                        {
                            path: '/accountapply',
                            name: 'accountapply',
                            meta: {
                                title: '账户申请查询',
                                icon: ''
                            },
                            component: () =>
                                import ('@/views/query/accountapply.vue')
                        },
                        {
                            path: '/accountconfirm',
                            name: 'accountconfirm',
                            meta: {
                                title: '账户确认查询',
                                icon: ''
                            },
                            component: () =>
                                import ('@/views/query/accountconfirm.vue')
                        },
                        {
                            path: '/tradeapply',
                            name: 'tradeapply',
                            meta: {
                                title: '交易申请查询',
                                icon: ''
                            },
                            component: () =>
                                import ('@/views/query/tradeapply.vue')
                        },
                        {
                            path: '/tradeconfirm',
                            name: 'tradeconfirm',
                            meta: {
                                title: '交易确认查询',
                                icon: ''
                            },
                            component: () =>
                                import ('@/views/query/tradeconfirm.vue')
                        }
                    ]
                },
                {
                    path: '/account',
                    name: 'account',
                    meta: {
                        title: '账户管理',
                        icon: 'el-icon-suitcase'
                    },
                    component: () =>
                        import ('@/views/account/index.vue'),
                    children: [{
                            path: '/changepwd',
                            name: 'changepwd',
                            meta: {
                                title: '账户密码修改',
                                icon: ''
                            },
                            component: () =>
                                import ('@/views/account/changepwd.vue')
                        },
                        {
                            path: '/selfinfo',
                            name: 'selfinfo',
                            meta: {
                                title: '账户信息查询',
                                icon: ''
                            },
                            component: () =>
                                import ('@/views/account/selfinfo.vue')
                        },
                        {
                            path: '/account',
                            name: 'account',
                            meta: {
                                title: '预留银行账户查询',
                                icon: ''
                            },
                            component: () =>
                                import ('@/views/account/bankinfo.vue')
                        },
                        {
                            path: '/investinfo',
                            name: 'investinfo',
                            meta: {
                                title: '投资机构信息查询',
                                icon: ''
                            },
                            component: () =>
                                import ('@/views/account/investinfo.vue')
                        }
                    ]
                }
            ],
        }
    ]
})

router.beforeEach((to, from, next) => {
  const loginData = Vue.prototype.$storage.getLogin();
  if (loginData && loginData.activeState === '1' && (to.path !== 'login' && to.path !== '/') && from.path === '/changepwd') {
    Vue.prototype.$message.warning('为了您的账户安全，请修改密码');
    Bus.$emit('intercept', from.path);
    next(false);
  } else {
    next();
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js